<template>
	<div class="bb-panel-wrapper">
		<section class="color-bars-container">
			<span class="b360-form-label" role="heading">Select Colors</span>
			<ColorBar
				v-if="userColorPalette.show"
				:colorGroup="userColorPalette"
				:key="0"
				:colorIndex="1"
			/>
			<ColorBar
				v-if="companyColorPalette.show"
				:colorGroup="companyColorPalette"
				:key="1"
				:colorIndex="2"
			/>
			<template v-if="palettes && palettes.length">
				<ColorBar
					v-for="(palette, index) in palettes"
					:key="index + 3"
					:colorIndex="index + 3"
					:colorGroup="palette"
				/>
			</template>
			<!-- TODO: Determine if the below situation can happen anymore.
      If there is no selectedImage.  Use the first media's palette.-->
			<template v-if="!palettes || !palettes.length">
				<ColorBar
					v-for="(palette, index) in $store.state.brandBuilderEditor
						.campaignItems[0].medias[0].palettes"
					:key="index + 3"
					:colorIndex="index + 3"
					:colorGroup="palette"
				/>
			</template>
		</section>
		<button class="b360-btn b360-btn--workspace-primary" @click="nextStep()">
			Next Step
		</button>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ColorBar from '@/components/brand-builder/ColorBar.vue';
import { MEDIA_ID } from '@/constants/brand-builder';

export default {
	name: 'BbColors',
	components: {
		ColorBar,
	},
	// TODO: showMoreOptions used?, wrong way to setup data?
	data: () => ({
		showMoreOptions: false,
	}),
	computed: {
		...mapState({
			palettes: (state) => state.brandBuilderEditor.selectedImage.palettes,
			brandBuilderEditor: (state) => state.brandBuilderEditor,
			selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
		}),
		...mapGetters(['userColorPalette', 'companyColorPalette']),
	},
	methods: {
		...mapActions(['selectColors', 'toggleSmPreview']),
		nextStep() {
			const previewButton = document.querySelector('.bb-tool-sm-preview');
			const mobilePreviewDisplay =
				window.getComputedStyle(previewButton).display;
			// eslint-disable operator-linebreak
			if (
				this.selectedMediaType === MEDIA_ID.FLYER ||
				this.selectedMediaType === MEDIA_ID.EMAIL
			) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/branding`,
				});
			} else if (
				this.selectedMediaType === MEDIA_ID.SOCIAL_MEDIA &&
				mobilePreviewDisplay !== 'none'
			) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/sm-preview`,
				});
				this.toggleSmPreview('on');
			} else if (this.selectedMediaType === MEDIA_ID.SOCIAL_MEDIA) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/export`,
				});
			} else if (this.selectedMediaType === MEDIA_ID.PRICING_FLYER) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/text`,
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.color-bars-container {
	margin-bottom: 25px;
}

.color-bar {
	& + & {
		margin-top: 10px;
	}
}

.b360-btn--workspace-secondary {
	margin-bottom: 15px;
}

.color-pickers-container {
	margin-bottom: 30px;
}
</style>
